/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Type_Daily_SummaryInputs */

const en_jobs_type_daily_summary = /** @type {(inputs: Jobs_Type_Daily_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily lesson summary`)
};

const he_jobs_type_daily_summary = /** @type {(inputs: Jobs_Type_Daily_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סיכום שיעורים יומי`)
};

/**
* | output |
* | --- |
* | "Daily lesson summary" |
*
* @param {Jobs_Type_Daily_SummaryInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_type_daily_summary = /** @type {((inputs?: Jobs_Type_Daily_SummaryInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Type_Daily_SummaryInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_type_daily_summary(inputs)
	return he_jobs_type_daily_summary(inputs)
});